import React, { Fragment, useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
import BiHelp from './BiHelp';

const BiCheckBoxList = ({
    mainKey,
    items,

    selected,
    onChange,
    onClick,
    name,
    label,
    style,
    disabled,


    help,
    helpKey,
    helpMainKey
}) => {


    const [sty, setStyle] = useState("form-check");

    useEffect(() => {
        if (style != null) {
            setStyle("form-check form-switch")
        }

    }, [style]);


    //ko se spremeni item
    const onCBChange = (e, item) => {
        const { checked } = e.currentTarget;
        
        if (onChange) {
            onChange(checked, name, items, item);
        }
    }


    const renderlist = () => {


        if (items == null) {
            return null;
        }
        return (

        <div>
            
                {items.map((item, index) =>

                    <div className="form-check form-switch" key={name + "_" + item.id + "_" + index}  >
                        <input disabled={disabled ? "disabled" : ""} className="form-check-input" type="checkbox" id={name + "_" + item.id} checked={item.izbran} name={name + "_" + item.id} onChange={(e) => onCBChange(e, item)} />


                        <label  className="form-check-label" htmlFor={name + "_" + item.id}>
                            {item.naziv}
                        </label>
                    </div>
                )}
            </div>

        );


    }


    return (
        <Fragment>
            <div className={sty} style={{ display: "inline-block" }}>

                {renderlist()}






            </div>

        </Fragment>
    );
}

export default BiCheckBoxList;